import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {hooks} from 'lib.front';

const RouteWithLayout = props => {
   const {
      layout: Layout,
      component: Component,
      condition,
      conditionPathRedirect,
      queryOrigin,
      title,
      ...rest
   } = props;
   hooks.useChangeTitle(title, {app: 'DS-Key', defaultTitle: 'DS-Key'});

   if (typeof condition === 'undefined' || condition === true) {
      return (
         <Route
            {...rest}
            render={matchProps => (
               <Layout>
                  <Component {...matchProps} />
               </Layout>
            )}
         />
      );
   }

   return (
      <Route
         {...rest}
         render={matchProps => {
            const to = queryOrigin
               ? {
                    pathname: conditionPathRedirect,
                    search: `?origin_uri=${matchProps.location.pathname}`
                 }
               : conditionPathRedirect;
            return <Redirect to={to} />;
         }}
      />
   );
};

export default RouteWithLayout;
